export { SvgIcon } from './SvgIcon';
export type { SvgIconPropsWithChildren, SvgIconProps } from './SvgIcon.types';
